import axios from '../../../helpers/custom-axios';
import { confirmation, notify } from '../../../helpers/notifications';

export const createCalendarEvent = async (calendar_event) => {
  return await axios
    .post('manage/calendar_events', calendar_event)
    .then((res) => {
      notify.success();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

export const updateCalendarEvent = async (id, calendar_event) => {
  return axios
    .put(`manage/calendar_events/${id}`, calendar_event)
    .then((res) => {
      notify.saved();
      return res;
    })
    .catch((error) => {
      notify.failure();
      return error;
    });
};

export const destroyCalendarEvent = async (id, callback) => {
  const destroyEvent = async () => {
    return axios
      .delete(`manage/calendar_events/${id}`)
      .then((res) => {
        notify.success();
        callback(res);
      })
      .catch((error) => {
        notify.failure();
        callback(error);
      });
  };

  confirmation.destroy(destroyEvent);
};

export const downloadICSFile = async (id) => {
  return axios
    .get(`manage/calendar_events/${id}/event`, { responseType: 'blob' })
    .then((res) => {
      notify.success();
      return res;
    })
    .catch((error) => {
      notify.failure();
      console.error('network failure', error);
      return error;
    });
};

export const downloadAllEvents = async (field_id, email) => {
  return axios
    .get(`manage/calendar_events/all_events`, {
      params: { field_id, email },
      responseType: 'blob',
    })
    .then((res) => {
      notify.success();
      return res;
    })
    .catch((error) => {
      notify.failure();
      console.error('network failure', error);
      return error;
    });
};
